<template>
  <div>
    <h5 class="text-center text-darked p-3 m-0">
      {{ skillName }}
    </h5>
    <p class="m-0 text-muted">
      Complete the answers and create your plan.
    </p>
    <hr class="my-2" />
    <b-form v-on:submit.prevent="validateSendData()" class="container" v-model="formModel">
      <span v-for="(item, idx) in questions" :key="idx">
        <multiple-choice
          v-if="item.type_question == '1'"
          :options="item.option_answers"
          :question="item.question"
          :index="idx + 1"
          :id="item.id"
          :ref="`question${item.id}`"
          :answers="item.answers"
          class="mb-3"
          :required="item.answers ? true : false"
        />
        <single-choice
          v-if="item.type_question == '2'"
          :options="item.option_answers"
          :question="item.question"
          :index="idx + 1"
          :id="item.id"
          :ref="`question${item.id}`"
          :answers="item.answers"
          class="mb-3"
          :required="item.answers ? true : false"
        />

        <range
          v-if="item.type_question == '3'"
          :min_value="item.min_value"
          :max_value="item.max_value"
          :min_label="item.min_label"
          :max_label="item.max_label"
          :question="item.question"
          :index="idx + 1"
          :id="item.id"
          :ref="`question${item.id}`"
          :answers="item.answers"
          class="mb-3"
          :required="item.answers ? true : false"
        />

        <open-answer
          v-if="item.type_question == '4'"
          :question="item.question"
          :index="idx + 1"
          :id="item.id"
          :ref="`question${item.id}`"
          :answers="item.answers"
          class="mb-3"
          :required="item.answers ? true : false"
        />

        <fill-table
          v-if="item.type_question == '5'"
          :column_1="item.column_1"
          :column_2="item.column_2"
          :question="item.question"
          :index="idx + 1"
          :id="item.id"
          :ref="`question${item.id}`"
          :answers="item.answers"
          class="mb-3"
          :required="item.answers ? true : false"
        />

        <fill-time
          v-if="item.type_question == '6'"
          :question="item.question"
          :index="idx + 1"
          :id="item.id"
          :ref="`question${item.id}`"
          :answers="item.answers"
          class="mb-3"
          :required="item.answers ? true : false"
        />
      </span>
      <b-button
        type="submit"
        variant="warning"
        class="my-3"
        block
        :disabled="
          (questions.find((q) => q && q.answers) && !formModel) ||
          (generateAnswers() && generateAnswers().find((o) => o.answer))
            ? false
            : true
        "
      >
        Save
      </b-button>
    </b-form>
  </div>
</template>
<script>
import multipleChoice from '@/components/planning/question//multipleChoice.vue';
import singleChoice from '@/components/planning/question//singleChoice.vue';
import range from '@/components/planning/question//range.vue';
import openAnswer from '@/components/planning/question//openAnswer.vue';
import fillTable from '@/components/planning/question//fillTable.vue';
import fillTime from '@/components/planning/question//fillTime.vue';
import { mapGetters, mapActions } from 'vuex';

export default {
  data() {
    return {
      questions: [],
      formModel: null,
      firstValidation: true,
    };
  },
  components: {
    multipleChoice,
    singleChoice,
    range,
    openAnswer,
    fillTable,
    fillTime,
  },
  props: {
    skillQuest: Array,
    Mid: String,
    skillName: String,
    editMode: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    ...mapActions('planning', ['createSkillPlan']),
    generateAnswers() {
      let answers = [];
      this.skillQuest.forEach((element) => {
        let id = parseInt(element.id, 10);
        if (this.$refs['question' + id]) {
          let vueComponent = this.$refs['question' + id][0];
          let response = {};
          switch (element.type_question) {
            case '1':
              vueComponent.selected.forEach((itemSelected) => {
                response = {
                  question: id,
                  answer: itemSelected,
                };
                if (itemSelected in vueComponent.inputExtraData) {
                  response['additional_data'] = vueComponent.inputExtraData[id];
                }
                answers.push(response);
              });
              break;
            case '2':
              response = {
                question: id,
                answer: vueComponent.selected,
              };

              vueComponent.options.forEach((element) => {
                if (element.id == vueComponent.selected && element.need_extra_data) {
                  response['additional_data'] = vueComponent.inputExtraData;
                }
              });
              answers.push(response);
              break;
            case '3':
              answers.push({
                question: id,
                answer: vueComponent.selected,
              });
              break;
            case '4':
              answers.push({
                question: id,
                answer: vueComponent.inputData,
              });
              break;
            case '5':
              vueComponent.tableRows.forEach((itemSelected) => {
                answers.push({
                  question: id,
                  answer: itemSelected.column1,
                  additional_data: itemSelected.column2,
                });
              });
              break;
            case '6':
              answers.push({
                question: id,
                answer: vueComponent.value,
              });
              break;
            default:
              console.log('Is Other');
              break;
          }
        }
      });

      return answers || [];
    },
    validateSendData() {
      this.createSkillPlan({
        parent: this.getUserId,
        answers: this.generateAnswers(),
      }).then(() => {
        this.$parent.reloadAnswers();
      });
    },
  },
  computed: {
    ...mapGetters('user', ['getUserId']),
    ...mapGetters('planning', ['getPlanAnswers']),
  },
  mounted() {
    if (this.getPlanAnswers != null && this.getPlanAnswers.length != 0) {
      this.getPlanAnswers.forEach((answer) => {
        this.skillQuest.forEach((question) => {
          if (answer.id == question.id) {
            question['answers'] = answer.parent_reponses;
            this.questions.push(question);
          }
        });
      });
    }
  },
};
</script>
